import { QueryClient } from "@tanstack/react-query";

/**
 * Shared query defaults.
 *
 * `staleTime` of a minute stops a PWA from refetching everything each time it
 * is brought back to the foreground, while `retry` backs off on genuine
 * failures without hammering an offline connection.
 */
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        gcTime: 5 * 60_000,
        retry: (failureCount, error) => {
          // Don't retry auth/permission errors — they won't fix themselves.
          const status = (error as { status?: number }).status;
          if (status && status >= 400 && status < 500) return false;
          return failureCount < 2;
        },
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
